import { urlWithParams } from '@marketplace-web/browser/url-util'

export const MEMBER_PROFILE_URL = (id: string | number, closetPromotionPrecheckout?: boolean) =>
  urlWithParams(`/member/${id}`, { cp_precheckout: closetPromotionPrecheckout })
export const EDIT_ITEM_URL = (id: number, origin?: string) =>
  `/items/${id}/edit${origin ? `?origin=${origin}` : ''}`
export const TERMS_URL = '/terms_and_conditions'
